module.exports = __webpack_public_path__ + "static/media/CSI-NL2.89f1522a.jpg";